import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import i18n from '@/libs/i18n'

import * as VueGoogleMaps from 'vue2-google-maps'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFacebookF, faInstagram, faGooglePlusG, faLine,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMobileDetection from 'vue-mobile-detection'
import { firebaseAuth } from '../firebase'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

library.add(faFacebookF, faInstagram, faGooglePlusG, faLine)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(require('vue-moment'))

Vue.use(VueMobileDetection)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBy9dxeHxy7MQRg1UsiN1ZOUhtTfUgSin8',
    libraries: 'places',
    language: 'zh-TW',
  },
})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import feather icon
require('@core/assets/fonts/feather/iconfont.css')

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    isEmpty(obj) {
      return [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length
    },
  },
})

let app

const init = () => {
  if (!app) {
    app = new Vue({
      i18n,
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  }
}

firebaseAuth.onAuthStateChanged(user => {
  if (user) {
    store.dispatch('fetchUserProfile')
  } else {
    store.commit('setMutation', { keyName: 'user', object: null })
  }

  init()
})
